import { useLocation } from "react-router-dom";

export const useContainsURL = (path: string) => {
  let location = useLocation();

  return location.search.includes(path);
};
